import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_BUILD_FUND_DECLARE_BEDANKT: MijnRoute = {
    path: 'bouwdepot/declaratie/bedankt',
    navigationEvent: 'toBouwdepotDeclaratieBedankt',
    regex: /^\/hypotheek\/bouwdepot\/declaratie\/bedankt$/,
    webcomponent: 'mijn-hypotheken-bouwdepot-webcomponent',
    internalPath: 'declaratie/bedankt'
};
